/* eslint-disable */
import PostFilter from '../classes/postfilter';

export default {
  init() {

    /* new PostFilter({
       ajaxLoadedCallback: function (container, elems ) {
        document.dispatchEvent( new Event('mustReloadWaypoints') );
      }
    }); */

  },
};



// WEBPACK FOOTER //
// ./scripts/routes/archive.js